import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';

const CuetMockLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Load Bootstrap
    const link1 = document.createElement("link");
    link1.href = "/assets/cuet-mock/css/bootstrap.css"; 
    link1.rel = "stylesheet";
    link1.id = "cuet-bootstrap";
    document.head.appendChild(link1);
    
    // 2. Load Custom Style
    const link2 = document.createElement("link");
    link2.href = "/assets/cuet-mock/css/style.css";
    link2.rel = "stylesheet";
    link2.id = "cuet-style";
    document.head.appendChild(link2);

    // 3. Load Font Awesome
    const link3 = document.createElement("link");
    link3.href = "/assets/cuet-mock/css/font-awesome.min.css";
    link3.rel = "stylesheet";
    link3.id = "cuet-fontawesome";
    document.head.appendChild(link3);

    // Add class for specific scoping if needed
    document.body.classList.add('cuet-simulation-mode');

    return () => {
      // Cleanup
      const l1 = document.getElementById("cuet-bootstrap");
      const l2 = document.getElementById("cuet-style");
      const l3 = document.getElementById("cuet-fontawesome");
      
      if(l1) document.head.removeChild(l1);
      if(l2) document.head.removeChild(l2);
      if(l3) document.head.removeChild(l3);
      
      document.body.classList.remove('cuet-simulation-mode');
    };
  }, []);

  const handleLogout = (e) => {
      e.preventDefault();
      // Clear mock user session
      localStorage.removeItem('mockCuetUser');
      // Redirect to mock login page
      navigate('/services/counselling/login');
  };

  return (
    <div className="cuet-mock-iso" style={{ minHeight: '100vh', background: '#fff', color: '#000', fontSize: '14px', fontFamily: '"Open Sans", sans-serif', marginTop:'80px' }}>
      
      {/* Header Simulation */}
      <section className="headerfirst" style={{background: '#fff', borderBottom: '1px solid #ccc'}}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <img className="img-responsive pull-left" src="/assets/cuet-mock/images/Handler1.png" style={{borderWidth:'0px'}} alt="Logo Left" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <h1 className="text-center" style={{color: '#333', fontSize: '26px', fontWeight: 'bold', marginTop: '20px'}}>
                            <span>Common University Entrance Test</span>
                        </h1>
                        <h3 className="text-center" style={{color: '#333', fontSize: '18px'}}>
                            <span>CUET UG - 2026</span>
                        </h3>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <img className="img-responsive pull-right" src="/assets/cuet-mock/images/Handler1_002.png" style={{borderWidth:'0px'}} alt="Logo Right" />
                    </div>
                </div>
            </div>
      </section>
      
      {/* Simulation Nav - EXACT STRUCTURE FROM NTA */}
      <nav className="navbar navbar-inverse active" style={{borderRadius: 0, marginBottom: '20px'}}>
            <div className="container-fluid">
                <div className="row">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className="expand navbar-collapse" id="myNavbar">
                        <ul className="nav navbar-nav">
                            <li>
                                <Link to="/services/counselling/dashboard" id="ctl00_lihome">
                                    <i className="fa fa-home">&nbsp;</i>Home
                                </Link>
                            </li>
                            <li id="ctl00_lichgpwd">
                                <Link to="#" onClick={(e) => e.preventDefault()}>Change Password</Link>
                            </li>
                            <li>
                                <a href="#" onClick={handleLogout}>Logout</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
      </nav>

      <Outlet />
      
       <section className="footersec footerMob bottom-div" style={{background: '#333', color: '#fff', padding: '10px 0', marginTop: '50px'}}>
            <div>
                <div className="row" style={{paddingLeft: '10px'}}>
                    <div className="col-sm-10">
                        <p className="text-left">
                            <b>Disclaimer:</b><br />
                            <span>This is a MOCK simulation for practice purposes only. Not the official NTA website.</span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
  );
};

export default CuetMockLayout;